import React from "react";

import { Button, FormErrorMessage } from "../../_common";

import { Box, Grid } from "@material-ui/core";
import useStyles from "./styles";

const FormContainer = ({
  children,
  handleSubmit,
  buttonState = true,
  isButtonLoading,
  buttonLabelText,
  errorMessage
}) => {
  const { formContainer, formWrapper, submitWrapper } = useStyles();
  return (
    <Grid container className={formWrapper}>
      <Grid container className={formContainer}>
        {children}
        {errorMessage && <FormErrorMessage errorMessage={errorMessage} />}
        {handleSubmit && (
          <Box className={submitWrapper}>
            <Button
              handleClick={handleSubmit}
              disabled={!buttonState}
              isLoading={isButtonLoading}
            >
              {buttonLabelText || "Guardar"}
            </Button>
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default FormContainer;
